import React, { useEffect, useRef, useState } from 'react';
import DataTable from 'react-data-table-component';
import moment from 'moment';
import { Button, Card, CardBody, CardFooter, CardHeader, Col, Row } from 'reactstrap';
import { hasPermission } from '../../../../Helpers/Helpers';
import { PermissionConstants } from '../../../../Helpers/Constants/permissions';
import { Constant } from '../../../../Helpers/constant';
import CustomTable from '../../../../Common/Table/Table';
import downloadImage from '../../../../../assets/images/download.svg';

const Table = props => {
  const [data, setData] = useState([]);
  const [bookingData, setBookingData] = useState([]);
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    if (props?.data?.length > 0) {
      setBookingData(
        props?.data?.map(booking => {
          return { ...booking };
        }),
      );
    } else {
      setData([]);
    }
  }, [props?.data]);

  useEffect(() => {
    if (bookingData?.length > 0) {
      const fetchColums = [
        {
          name: 'S.No',
          selector: row => <span className="fw-medium">{row?.serialNumber}</span>,
          width: '90px',
        },
        {
          name: 'Name',
          selector: row => row?.name,
          wrap: true,
          width: '200px',
        },
        {
          name: 'Email',
          selector: row => row?.email,
          wrap: true,
          minWidth: '250px',
        },
        {
          name: 'Mobile',
          selector: row => row?.phoneNumber,
          wrap: true,
          width: '180px',
        },

        {
          name: 'City',
          selector: row => row?.city,
          wrap: true,
          width: '180px',
        },

        {
          name: 'Register At',
          selector: row => row?.registerAt,
          wrap: true,
          width: '180px',
        },

        {
          name: 'Actions',
          width: '180px',
          cell: row => (
            <div className="d-flex justify-content-center flex-column w-100 my-2">
              {hasPermission(PermissionConstants?.ALL_PERMISSIONS?.UPDATE_CUSTOMER) && (
                <span
                  className="btn btn-sm btn-primary mb-1"
                  onClick={() => {
                    actionBtnHandler(`UPDATE`, row?.data);
                  }}
                >
                  Update Details
                </span>
              )}

              {JSON.parse(localStorage.getItem('data'))?.program?.configuration?.payment?.cardDirectory?.isActive && (
                <span
                  className="btn btn-sm btn-primary mb-1"
                  onClick={() => {
                    actionBtnHandler(`CARD_LIST`, row?.data);
                  }}
                >
                  Card List
                </span>
              )}

              {true && (
                <span
                  className="btn btn-sm btn-primary mb-1"
                  onClick={() => {
                    ['THRIWE_APP', 'HSBC_BEACH_CLUB', 'GLOBE_TOYOTA', 'HDFC_BUNDLE', 'MASTERCARD_CL', 'ENBD_NATIONAL_DAY', 'MASTERCARD_FAB'].includes(
                      Constant.PROJECT_CODE,
                    )
                      ? actionBtnHandler(`MEMBERSHIPS_THRIWE_APP`, row?.data)
                      : actionBtnHandler(`MEMBERSHIPS`, row?.data);
                  }}
                >
                  Memberships
                </span>
              )}
            </div>
          ),
        },
      ];
      setColumns(fetchColums);
      setData(
        props?.data?.map((data, index) => {
          return {
            serialNumber: `${props.pageNumber * Constant.TABLE_PAGE_SIZE + (index + 1)}.`,
            name: `${data?.firstName ?? ''} ${data?.lastName ?? ''}` || ``,
            email: data?.email || ``,
            phoneNumber: `${data?.countryCode ? `+${data?.countryCode}-` : ''}${data?.phoneNumber ?? ''}` || ``,
            registerAt: data?.createdAt ? moment(data?.createdAt).utc().format('DD-MM-YYYY, h:mm A') + ' (UTC)' : 'NA',
            city: data?.addresses?.[0]?.subregion || 'NA',
            data,
          };
        }),
      );
    } else {
      setData([]);
      setColumns([]);
    }
  }, [bookingData]);

  /* ---------------------------- ACTION HANDLER ---------------------------- */
  const actionBtnHandler = (flag, data) => {
    if (flag === `CARD_LIST`) {
      props.actionHandler({
        details: data,
        actionType: flag,
      });
    } else if (flag === `MEMBERSHIPS`) {
      props.actionHandler({
        details: data,
        actionType: flag,
      });
    } else if (flag === `UPDATE`) {
      props.actionHandler({
        details: data,
        actionType: flag,
      });
    } else if (flag === `MEMBERSHIPS_THRIWE_APP`) {
      props.actionHandler({
        details: data,
        actionType: flag,
      });
    }
  };
  return (
    <>
      <Row>
        <Col xxl={12}>
          <Card>
            <CardHeader className="d-flex justify-content-end">
              <h4 className="card-title mb-0 flex-grow-1">Customer List</h4>

              {hasPermission(PermissionConstants?.ALL_PERMISSIONS?.CLIENT_DOWNLOAD_ACCESS) && props?.data?.length > 0 && (
                <Button onClick={props?.dumpDownload} className="download-dump-btn">
                  Download <img src={downloadImage} alt="Download" width="20" height="20" />
                </Button>
              )}
            </CardHeader>

            <CardBody>
              <CustomTable
                columns={columns ?? []}
                data={data ?? []}
                totalCount={props.totalCount}
                limit={props.limit}
                handleRowsPerPageChange={props.handleRowsPerPageChange} // Allows rows-per-page customization
                currentPage={props.pageNumber}
                handlePageChange={props.handlePageChange}
                indexType={Constant.INDEX_TYPE.ZERO_BASED}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Table;
